<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="13" viewBox="0 0 9 13">
    <g id="Group_546" data-name="Group 546" transform="translate(-0.312)">
      <path id="Polygon_8" data-name="Polygon 8" d="M4.5,0,9,5H0Z" transform="translate(9.312 13) rotate(180)" />
    </g>
  </svg>
</template>
